module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"links":"Navigation:","copyrights":"Blocktech Consulting OÜ","contact":{"subheader":"Contact:","email":"Email Address","website":"Website"},"resources":{"subheader":"Checkout our resources","github":"Github"}}}')
  delete Component.options._Ctor
}
